import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//申请发票(带token)
export function complaintByOrderId(data) {
    return fetch({
        url: config.WEB_ADDCOMPLAINT_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}